import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiActivity } = FiIcons;

const MobileHeader = ({ onMenuClick }) => {
  return (
    <div className="lg:hidden bg-gray-800 border-b border-gray-700 p-4 sticky top-0 z-30">
      <div className="flex items-center justify-between">
        <button onClick={onMenuClick} className="p-2 text-gray-400 hover:text-white">
          <SafeIcon icon={FiMenu} className="w-6 h-6" />
        </button>
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg">
            <SafeIcon icon={FiActivity} className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-white tracking-tight">Carson Exports</span>
        </div>
        <div className="w-10"></div>
      </div>
    </div>
  );
};

export default MobileHeader;